import { render } from "./page-service.vue?vue&type=template&id=f5b2af3a&scoped=true"
import script from "./page-service.vue?vue&type=script&lang=js"
export * from "./page-service.vue?vue&type=script&lang=js"

import "./page-service.vue?vue&type=style&index=0&id=f5b2af3a&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b2af3a"]])

export default __exports__